import React from 'react';
import PropTypes from 'prop-types';
import { DragSource } from 'react-dnd';
import DraggableItemTypes from 'components/draggable.item.types';
import { iconBranching, iconThankYouRoute } from 'utils/svgConstants';
import { removePseudoTags } from 'utils/coercionUtils';
import TrashCan from './TrashCan';
import Grip from './grip_2x_dark.png';

const dragSource = {
  canDrag(props) {
    return !props.isBranchingField;
  },

  beginDrag(props) {
    props.onDrag();
    return {
      keyPath: props.keyPath,
    };
  },

  endDrag(props, monitor) {
    if (monitor.didDrop()) {
      const { targetIndex, targetStep, branchingStep } = monitor.getDropResult();
      if ((branchingStep && (targetStep <= branchingStep)) && props.branchMembership.length) {
        props.toggleModal({
          onConfirm: () => {
            props.removeAllUserBranchMembership();
            props.reorderField(props.index, targetIndex);
          },
        });
      } else {
        props.reorderField(props.index, targetIndex);
      }
    }
    props.onDrop();
  },
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  };
}

const FieldHeader = (props) => {
  const {
    branchMembership,
    index,
    isBranchingField = false,
    isRequiredField,
    keyPath,
    onDelete,
    rightText = '',
    title = '',
    toggleFieldCollapsedState,
    isThankYouField = false,
  } = props;

  const branchMemberAdditions = (
    <div>
      <svg className="fill-branching-green mr-2" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512">
        <g transform="rotate(270, 256, 256)">
          <path d={iconBranching} />
        </g>
      </svg>
      <span className="mr-2 branch-member">
        {branchMembership.length ? branchMembership.join(', ') : 'All Branches'}
      </span>
    </div>
  );

  return props.connectDragSource(
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    <div className={`card-header px-4 py-2 ${isBranchingField ? 'bg-branching-green' : 'bg-light'}${title ? '' : ' text-muted'}`} onClick={() => toggleFieldCollapsedState(index)} role="button" tabIndex="0">
      <img src={Grip} height="9" width="37" alt="drag card" style={{ right: '50%' }} className="mt-1 position-absolute" />
      <div className="my-1 d-flex align-items-center">
        <div className="d-flex align-items-center flex-grow-1">
          {
            isBranchingField ? (
              <svg className="mr-2" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
                <circle className="fill-branching-green" cx="256" cy="256" r="256" />
                <g transform="rotate(180, 256, 256) scale(.785) translate(70, 90)">
                  <path className="fill-white" d={iconBranching} />
                </g>
              </svg>
            ) : null
          }
          {
            isThankYouField ? (
              <svg className="mr-2" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 512 512">
                <circle className="fill-thank-you-transparent" cx="256" cy="256" r="256" />
                <g transform="scale(.785) translate(70, 90)">
                  <path className="fill-branching-gray" d={iconThankYouRoute} />
                </g>
              </svg>
            ) : null
          }
          <h2 className="h5 mb-0">{title.length ? removePseudoTags(title) : 'New Field'}</h2>
        </div>
        <div className="text-secondary" style={{ maxWidth: '50%' }}>
          <div className="d-flex">
            {isBranchingField ? null : branchMemberAdditions}
            <span id={`${[...keyPath, 'rules-status'].join('-')}`} className="mr-3 align-bottom">{rightText}</span>
            <TrashCan
              disabled={isBranchingField || isRequiredField}
              keyPath={keyPath}
              onDelete={onDelete}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

FieldHeader.propTypes = {
  branchMembership: PropTypes.array.isRequired,
  isRequiredField: PropTypes.bool.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  isBranchingField: PropTypes.bool,
  isThankYouField: PropTypes.bool,
  keyPath: PropTypes.array.isRequired,
  onDelete: PropTypes.func.isRequired,
  onDrag: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
  rightText: PropTypes.string,
  title: PropTypes.string,
  toggleFieldCollapsedState: PropTypes.func.isRequired,
};

export default DragSource(DraggableItemTypes.FIELD_ITEM, dragSource, collect)(FieldHeader);
